import { z } from 'zod';
const groupMembershipShape = z
    .object({
    kind: z.enum(['admin', 'member']),
    role: z.string().nullable(),
    scope: z.enum(['all', 'specific']),
    accessibleOrgIds: z.array(z.string().uuid()),
})
    .strict();
const orgMembershipShape = z
    .object({
    organizationId: z.string().uuid(),
    organizationName: z.string(),
    organizationSlug: z.string(),
    primaryRole: z.string(),
    roles: z.array(z.string()),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
})
    .strict();
const userEntryShape = z
    .object({
    user: z
        .object({
        id: z.string().uuid(),
        email: z.string().email(),
        lastActiveAt: z.string().nullable(),
    })
        .strict(),
    groupMembership: groupMembershipShape.nullable(),
    organizationMemberships: z.array(orgMembershipShape),
})
    .strict();
export const groupMembersListResponseSchema = z
    .object({
    users: z.array(userEntryShape),
})
    .strict();
//# sourceMappingURL=group-members-list-response.schema.js.map